import { Link } from "react-router-dom"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-amber-800 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-4">Restaurant Automation</h3>
            <p className="text-amber-200 text-sm">
              Streamlining restaurant operations with cutting-edge technology solutions.
            </p>
          </div>

          <div>
            <h4 className="font-medium mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-amber-200 hover:text-white transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/browse-restaurants"
                  className="text-amber-200 hover:text-white transition-colors duration-200"
                >
                  Restaurants
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-amber-200 hover:text-white transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-amber-200 hover:text-white transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-4">For Restaurant Owners</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/owner/dashboard" className="text-amber-200 hover:text-white transition-colors duration-200">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link
                  to="/owner/restaurant-management"
                  className="text-amber-200 hover:text-white transition-colors duration-200"
                >
                  Manage Restaurant
                </Link>
              </li>
              <li>
                <Link to="/owner/analytics" className="text-amber-200 hover:text-white transition-colors duration-200">
                  Analytics
                </Link>
              </li>
              <li>
                <Link to="/payment" className="text-amber-200 hover:text-white transition-colors duration-200">
                  Become an Owner
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-4">Connect With Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="text-amber-200 hover:text-white transition-colors duration-200">
                <i className="fab fa-facebook-f"></i>
                <span className="sr-only">Facebook</span>
              </a>
              <a href="#" className="text-amber-200 hover:text-white transition-colors duration-200">
                <i className="fab fa-twitter"></i>
                <span className="sr-only">Twitter</span>
              </a>
              <a href="#" className="text-amber-200 hover:text-white transition-colors duration-200">
                <i className="fab fa-instagram"></i>
                <span className="sr-only">Instagram</span>
              </a>
              <a href="#" className="text-amber-200 hover:text-white transition-colors duration-200">
                <i className="fab fa-linkedin-in"></i>
                <span className="sr-only">LinkedIn</span>
              </a>
            </div>
            <p className="mt-4 text-sm text-amber-200">
              Email: contact@restaurantapp.com
              <br />
              Phone: (123) 456-7890
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-amber-700 text-center text-sm text-amber-300">
          <p>&copy; {currentYear} Restaurant Automation Platform. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
